import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent, SelectProps } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { SelectOption } from 'types/form';
import { useMemo } from 'react';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export type SharedMultipleSelectProps = SelectProps<string[]> & {
    options: SelectOption[];
    value: string[];
    helperText?: string;
};

export const MultipleSelectCheckmarks = ({
    options,
    value,
    helperText,
    inputProps,
    size,
    ...props
}: SharedMultipleSelectProps) => {
    const currentValue = useMemo(() => (typeof value === 'string' ? value.split(',') : value), [value]);

    return (
        <div>
            <FormControl sx={{ width: '100%' }} size={size}>
                <InputLabel id="multiple-checkbox-label">{props.label}</InputLabel>
                <Select
                    labelId="multiple-checkbox-label"
                    id="multiple-checkbox"
                    multiple
                    value={currentValue}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                    inputProps={{ ...inputProps, helperText }}
                    {...props}
                >
                    {options.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            <Checkbox checked={currentValue.indexOf(option.id) > -1} />
                            <ListItemText primary={option.name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};
